module.exports = __webpack_public_path__ + "img/高人效智能客服系统图片.364994cb.png";